import React from 'react';
import type { ListItemProps } from '@mui/material';
import { ListItem as MuiListItem } from '@mui/material';

// ✅ Must use forwardRef so DnD-kit can attach refs
const ListItem = React.forwardRef<HTMLLIElement, ListItemProps>(
  (props, ref) => {
    return (
      <MuiListItem ref={ref} {...props}>
        {props.children}
      </MuiListItem>
    );
  }
);

ListItem.displayName = 'ListItem'; // optional, for better debugging

export default ListItem;
